<template>
    <div class="px-5 py-4">
        <div v-if="entries.length > 0" class="text-xs tracking-wide text-gray-500 mb-3">{{ title }}</div>
        <div class="space-y-3">
            <div
                v-for="entry in entries"
                :key="entry.key"
                class="rounded border border-bordergray-100 overflow-hidden"
                :style="{ borderLeftWidth: '4px', borderLeftColor: entry.borderColor }"
            >
                <div class="px-3 py-2">
                    <div class="flex items-start justify-between gap-2">
                        <div class="text-sm font-medium text-gray-900 truncate whitespace-nowrap overflow-hidden text-ellipsis">
                            {{ entry.title }}
                        </div>
                        <div
                            v-if="showHours && entry.hoursText"
                            class="text-[11px] leading-4 flex-shrink-0"
                            :class="entry.status === 'cancelled' ? 'text-red-500 line-through' : 'text-gray-800'"
                        >
                            {{ entry.hoursText }}
                        </div>
                    </div>
                    <div v-if="entry.requestedText" class="text-xs text-gray-500 mt-1">
                        {{ entry.requestedText }}
                    </div>
                </div>
                <div class="px-3 py-2 border-t border-ultralight text-xs text-gray-500">
                    <div
                        v-if="entry.status === 'cancelled'"
                        class="inline-flex items-center text-red-500"
                    >
                        <span class="inline-block h-2 w-2 rounded-full mr-2 bg-red-500"></span>
                        <span>{{ entry.approvedText || 'Storniert' }}</span>
                    </div>
                    <div
                        v-else-if="entry.approvedText && String(entry.approvedText).toLowerCase() !== 'ausstehend'"
                        class="inline-flex items-center"
                    >
                        <span class="inline-block h-2 w-2 rounded-full mr-2 bg-green-500"></span>
                        <span>Freigegeben am {{ entry.approvedText }}</span>
                    </div>
                    <div v-else>Freigabe ausstehend</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "approval-sidebar-list",
    props: {
        title: {
            type: String,
            required: true,
        },
        entries: {
            type: Array,
            default: () => [],
        },
        showHours: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
